module.exports = __webpack_public_path__ + "static/media/arrow-bar-left.336d3dfb.svg";